export class DocumentFormat {
  id: number;
  description: string;
  isDefault: boolean;
}
